import { render } from "./WhatsappConnected.vue?vue&type=template&id=8a5678ea&scoped=true"
import script from "./WhatsappConnected.vue?vue&type=script&lang=js"
export * from "./WhatsappConnected.vue?vue&type=script&lang=js"

import "./WhatsappConnected.vue?vue&type=style&index=0&id=8a5678ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a5678ea"]])

export default __exports__